// extracted by mini-css-extract-plugin
export default {"hideOnMobile":"ngmFKgVYTvxBZ7SDODNd-classNames-hideOnMobile","showOnlyOnMobile":"CLo9Kzqnrjg505iUXr1z-classNames-showOnlyOnMobile"};